import { isMobileDevice } from "src/components/WidgetMaker/WidgetDnD/isMobileDevice";
import { COMMON_LAYOUT_TYPE } from "../../Testimonials/Constants";

const LINE_CLAMP_SETTING = {
  layout1: 'tw-line-clamp-1',
  layout2: 'tw-line-clamp-2',
  layout3: 'tw-line-clamp-1',
  layout4: 'tw-line-clamp-1',
}

function ProductText(props) {
  const { productName, isContentCenter, productUrl = '', listPresentationConfig } = props;
  const isMobile = isMobileDevice();
  const isLayout4 = listPresentationConfig?.layoutName === COMMON_LAYOUT_TYPE.FOUR

  function handleClick() {
    if (productUrl) {
      window.open(productUrl, '_blank');
    }
  }

  return (
    <div onClick={handleClick} className={`tw-text-[14px] tw-opacity-70 ${isMobile ? isLayout4 ? 'tw-line-clamp-1' : 'tw-line-clamp-2 tw-h-[45px]' :
      (LINE_CLAMP_SETTING?.[listPresentationConfig?.layoutName] || 'tw-line-clamp-1')} 
         tw-font-medium tw-leading-[1.6] tw-cursor-pointer tw-underline tw-text-newBlack
          ${(isContentCenter && (listPresentationConfig?.layoutName !== COMMON_LAYOUT_TYPE.THREE)) ? 'tw-text-center' : ''}
          `}>{productName}</div>
  )
}

export default ProductText;